var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-ag",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M-79.7 0H603v512H-79.7z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "translate(74.7) scale(.9375)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-120 0h763.3v511.5H-120z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-118.3.6h760.9v216.1h-761z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0061ff",
    d: "M21.3 203.2h505V317h-505z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e20000",
    d: "M642.8 1.8V512H262L642.8 1.7zm-761.5 0V512H262L-118.7 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd600",
    d: "M440.4 203.3 364 184l64.9-49-79.7 11.4 41-69.5-70.7 41L332.3 37l-47.9 63.8-19.3-74-21.7 76.3-47.8-65 13.7 83.2L138.5 78l41 69.5-77.4-12.5 63.8 47.8L86 203.3h354.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAg);
export default __webpack_public_path__ + "static/media/ag.b6e8a995ff2e6c759af0aee8683ecece.svg";
export { ForwardRef as ReactComponent };